// extracted by mini-css-extract-plugin
export default {"labelWithQuestion":"style_labelWithQuestion__a1Xcd","label":"style_label__oz22e","labelLighter":"style_labelLighter__Jd1tq"};